// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContactForm_wrapper__4tWs9","title_form":"ContactForm_title_form__8cl21","input":"ContactForm_input__1OYWq","add_contact_btn":"ContactForm_add_contact_btn__34nKB"};